import React, { useState } from 'react';
import { UserIcon, EnvelopeIcon, LockClosedIcon, EyeIcon, EyeSlashIcon, MapPinIcon } from '@heroicons/react/24/outline';

const LOCAL_AUTHORITIES = [
  'Aberdeen City Council',
  'Aberdeenshire Council',
  'Administration',
  'Adur District Council',
  'Allerdale Borough Council',
  'Amber Valley Borough Council',
  'Angus Council',
  'Antrim and Newtownabbey District Council',
  'Argyll & Bute Council',
  'Armagh Banbridge and Craigavon District Council',
  'Arun District Council',
  'Ashfield District Council',
  'Ashford Borough Council',
  'Aylesbury Vale District Council',
  'Babergh District Council',
  'Barnsley Metropolitan Borough Council',
  'Barrow-in-Furness Borough Council',
  'Basildon District Council',
  'Basingstoke and Deane Borough Council',
  'Bassetlaw District Council',
  'Bath and North East Somerset Council',
  'Bedford Borough Council',
  'Belfast City Council',
  'Birmingham City Council',
  'Blaby District Council',
  'Blackburn with Darwen Borough Council',
  'Blackpool Borough Council',
  'Blaenau Gwent County Borough Council',
  'Bolsover District Council',
  'Bolton Metropolitan Borough Council',
  'Boston Borough Council',
  'Bournemouth Borough Council',
  'Bournemouth, Christchurch and Poole',
  'Bracknell Forest Borough Council',
  'Braintree District Council',
  'Breckland District Council',
  'Brentwood Borough Council',
  'Bridgend County Borough Council',
  'Brighton and Hove Council',
  'Bristol City Council',
  'Broadland District Council',
  'Bromsgrove District Council',
  'Broxbourne Borough Council',
  'Broxtowe Borough Council',
  'Buckinghamshire',
  'Burnley Borough Council',
  'Bury Metropolitan Borough Council',
  'Caerphilly County Borough Council',
  'Calderdale Metropolitan Borough Council',
  'Cambridge City Council',
  'Cannock Chase District Council',
  'Canterbury City Council',
  'Cardiff County Council',
  'Carlisle City Council',
  'Carmarthenshire County Council',
  'Castle Point Borough Council',
  'Causeway Coast and Glens',
  'Central Bedfordshire',
  'Ceredigion County Council',
  'Charnwood Borough Council',
  'Chelmsford Borough Council',
  'Cheltenham Borough Council',
  'Cherwell District Council',
  'Cheshire East',
  'Cheshire West and Chester Council',
  'Chesterfield Borough Council',
  'Chichester District Council',
  'Chiltern District Council',
  'Chorley Borough Council',
  'Christchurch Borough Council',
  'City and County of Swansea',
  'City of Bradford',
  'City of Glasgow',
  'City of York Council',
  'Clackmannanshire Council',
  'Colchester Borough Council',
  'Comhairle nan Eilean Siar',
  'Conwy County Borough Council',
  'Copeland Borough Council',
  'Corby Borough Council',
  'Cornwall County Council',
  'Corporation of the City of London',
  'Cotswold District Council',
  'Coventry City Council',
  'Craven District Council',
  'Crawley Borough Council',
  'Dacorum Borough Council',
  'Darlington Borough Council',
  'Dartford Borough Council',
  'Daventry District Council',
  'Denbighshire County Council',
  'Derby City Council',
  'Derbyshire Dales District Council',
  'Derry City and Strabane District Council',
  'Doncaster Metropolitan Borough Council',
  'Dorset Council',
  'Dover District Council',
  'Dudley Metropolitan Borough Council',
  'Dumfries and Galloway Council',
  'Dundee City Council',
  'Durham',
  'East Ayrshire Council',
  'East Cambridgeshire District Council',
  'East Devon District Council',
  'East Dorset District Council',
  'East Dunbartonshire Council',
  'East Hampshire District Council',
  'East Hertfordshire District Council',
  'East Lindsey District Council',
  'East Lothian Council',
  'East Northamptonshire Council',
  'East Renfrewshire Council',
  'East Riding of Yorkshire',
  'East Staffordshire Borough Council',
  'East Suffolk Council',
  'Eastbourne Borough Council',
  'Eastleigh Borough Council',
  'Eden District Council',
  'Edinburgh City Council',
  'Elmbridge Borough Council',
  'Epping Forest District Council',
  'Epsom and Ewell Borough Council',
  'Erewash Borough Council',
  'Exeter City Council',
  'Falkirk Council',
  'Fareham Borough Council',
  'Fenland District Council',
  'Fermanagh and Omagh District Council',
  'Fife Council',
  'Flintshire County Council',
  'Folkestone & Hythe District Council',
  'Forest of Dean District Council',
  'Fylde Borough Council',
  'Gateshead Metropolitan Borough Council',
  'Gedling Borough Council',
  'Gloucester City Council',
  'Gosport Borough Council',
  'Gravesham Borough Council',
  'Great Yarmouth Borough Council',
  'Greater Manchester Authority',
  'Guildford Borough Council',
  'Gwynedd Council',
  'Halton Borough Council',
  'Hambleton District Council',
  'Harborough District Council',
  'Harlow District Council',
  'Harrogate Borough Council',
  'Hart District Council',
  'Hartlepool Borough Council',
  'Hastings Borough Council',
  'Havant Borough Council',
  'Herefordshire Council',
  'Hertsmere Borough Council',
  'High Peak Borough Council',
  'Highland Council',
  'Hinckley and Bosworth Borough Council',
  'Horsham District Council',
  'Huntingdonshire District Council',
  'Hyndburn Borough Council',
  'Inverclyde Council',
  'Ipswich Borough Council',
  'Isle of Anglesey County Council',
  'Isle of Wight Council',
  'Isles of Scilly - Council of the',
  'Kettering Borough Council',
  'Kings Lynn and West Norfolk Borough Council',
  'Kingston-upon-Hull City Council',
  'Kirklees Metropolitan Council',
  'Knowsley Metropolitan Borough Council',
  'Lancaster City Council',
  'Leeds City Council',
  'Leicester City Council',
  'Lewes District Council',
  'Lichfield District Council',
  'Lincoln City Council',
  'Lisburn City and Castlereagh District Council',
  'Liverpool City Council',
  'London Borough of Barking and Dagenham',
  'London Borough of Barnet',
  'London Borough of Bexley',
  'London Borough of Brent',
  'London Borough of Bromley Council',
  'London Borough of Camden',
  'London Borough of Croydon',
  'London Borough of Ealing',
  'London Borough of Enfield',
  'London Borough of Hackney',
  'London Borough of Hammersmith & Fulham',
  'London Borough of Haringey',
  'London Borough of Harrow',
  'London Borough of Havering',
  'London Borough of Hillingdon',
  'London Borough of Hounslow',
  'London Borough of Islington',
  'London Borough of Lambeth',
  'London Borough of Lewisham',
  'London Borough of Merton',
  'London Borough of Newham',
  'London Borough of Redbridge',
  'London Borough of Richmond',
  'London Borough of Southwark',
  'London Borough of Sutton',
  'London Borough of Tower Hamlets',
  'London Borough of Waltham Forest',
  'London Borough of Wandsworth',
  'London Borough of Westminster',
  'Luton Borough Council',
  'Maidstone Borough Council',
  'Maldon District Council',
  'Malvern Hills District Council',
  'Manchester City Council',
  'Mansfield District Council',
  'Medway Council',
  'Melton Borough Council',
  'Mendip District Council',
  'Merthyr Tydfil County Borough Council',
  'Mid and East Antrim District Council',
  'Mid Devon District Council',
  'Mid Suffolk District Council',
  'Mid Sussex District Council',
  'Mid Ulster District Council',
  'Middlesbrough Borough Council',
  'Midlothian Council',
  'Milton Keynes Borough Council',
  'Mole Valley District Council',
  'Monmouthshire Council',
  'Moray Council',
  'Neath Port Talbot County Borough Council',
  'New Forest District Council',
  'Newark and Sherwood District Council',
  'Newcastle City Council',
  'Newcastle-under-Lyme Borough Council',
  'Newport City Council',
  'Newry Mourne and Down District Council',
  'North Ayrshire Council',
  'North Devon District Council',
  'North Dorset District Council',
  'North Down and Ards District Council',
  'North East Derbyshire District Council',
  'North East Lincolnshire Council',
  'North Hertfordshire District Council',
  'North Kesteven District Council',
  'North Lanarkshire Council',
  'North Lincolnshire Council',
  'North Norfolk District Council',
  'North Somerset Council',
  'North Tyneside Council',
  'North Warwickshire Borough Council',
  'North West Leicestershire District Council',
  'Northampton Borough Council',
  'Northumberland Council',
  'Norwich City Council',
  'Nottingham City Council',
  'Nuneaton and Bedworth Borough Council',
  'Oadby and Wigston District Council',
  'Oldham Metropolitan Borough Council',
  'Orkney Islands Council',
  'Oxford City Council',
  'Pembrokeshire Council',
  'Pendle Borough Council',
  'Perth & Kinross Council',
  'Peterborough Council',
  'Plymouth City Council',
  'Poole Borough Council',
  'Portsmouth City Council',
  'Powys County Council',
  'Preston Borough Council',
  'Purbeck District Council',
  'Reading Borough Council',
  'Redcar and Cleveland Borough Council',
  'Redditch Borough Council',
  'Reigate and Banstead Borough Council',
  'Renfrewshire Council',
  'Rhondda-Cynon-Taff Council',
  'Ribble Valley Borough Council',
  'Richmondshire District Council',
  'Rochdale Metropolitan Borough Council',
  'Rochford District Council',
  'Rossendale Borough Council',
  'Rother District Council',
  'Rotherham Metropolitan Borough Council',
  'Royal Borough of Greenwich',
  'Royal Borough of Kensington & Chelsea',
  'Royal Borough of Kingston upon Thames',
  'Royal Borough of Windsor and Maidenhead',
  'Rugby Borough Council',
  'Runnymede Borough Council',
  'Rushcliffe Borough Council',
  'Rushmoor Borough Council',
  'Rutland County Council',
  'Ryedale District Council',
  'Salford Metropolitan Borough Council',
  'Sandwell Metropolitan Borough Council',
  'Scarborough Borough Council',
  'Scottish Borders Council',
  'Sedgemoor District Council',
  'Sefton Metropolitan Borough Council',
  'Selby District Council',
  'Sevenoaks District Council',
  'Sheffield City Council',
  'Shetland Islands Council',
  'Shropshire Council',
  'Slough Borough Council',
  'Solihull Metropolitan Borough Council',
  'Somerset West and Taunton Council',
  'South Ayrshire Council',
  'South Bucks District Council',
  'South Cambridgeshire District Council',
  'South Derbyshire District Council',
  'South Gloucestershire District Council',
  'South Hams District Council',
  'South Holland District Council',
  'South Kesteven District Council',
  'South Lakeland District Council',
  'South Lanarkshire Council',
  'South Norfolk District Council',
  'South Northamptonshire Council',
  'South Oxfordshire District Council',
  'South Ribble Borough Council',
  'South Somerset District Council',
  'South Staffordshire District Council',
  'South Tyneside Metropolitan Borough Council',
  'Southampton Council',
  'Southend Borough Council',
  'Spelthorne Borough Council',
  'St Albans City and District Council',
  'St Helens Metropolitan Borough Council',
  'Stafford Borough Council',
  'Staffordshire Moorlands District Council',
  'Stevenage Borough Council',
  'Stirling Council',
  'Stockport Metropolitan Borough Council',
  'Stockton-on-Tees Borough Council',
  'Stoke-on-Trent City Council',
  'Stratford on Avon District Council',
  'Stroud District Council',
  'Sunderland City Council',
  'Surrey Heath Borough Council',
  'Swale Borough Council',
  'Swindon Borough Council',
  'Tameside Metropolitan Borough Council',
  'Tamworth Borough Council',
  'Tandridge District Council',
  'Teignbridge District Council',
  'Telford and Wrekin Council',
  'Tendring District Council',
  'Test Valley Borough Council',
  'Tewkesbury Borough Council',
  'Thanet District Council',
  'Three Rivers District Council',
  'Thurrock Council',
  'Tonbridge and Malling Borough Council',
  'Torbay Borough Council',
  'Torfaen County Borough Council',
  'Torridge District Council',
  'Trafford Metropolitan Borough Council',
  'Tunbridge Wells Borough Council',
  'Uttlesford District Council',
  'Vale of Glamorgan Council',
  'Vale of White Horse District Council',
  'Wakefield Metropolitan District Council',
  'Walsall Metropolitan Borough Council',
  'Warrington Borough Council',
  'Warwick District Council',
  'Watford Borough Council',
  'Waverley Borough Council',
  'Wealden District Council',
  'Wellingborough Borough Council',
  'Welwyn Hatfield District Council',
  'West Berkshire Council',
  'West Devon Borough Council',
  'West Dorset District Council',
  'West Dunbartonshire Council',
  'West Lancashire Borough Council',
  'West Lindsey District Council',
  'West Lothian Council',
  'West Oxfordshire District Council',
  'West Suffolk Council',
  'Weymouth and Portland Borough Council',
  'Wigan Metropolitan Borough Council',
  'Wiltshire Council',
  'Winchester City Council',
  'Wirral Metropolitan Borough Council',
  'Woking Borough Council',
  'Wokingham Borough Council',
  'Wolverhampton City Council',
  'Worcester City Council',
  'Worthing Borough Council',
  'Wrexham County Borough Council',
  'Wychavon District Council',
  'Wycombe District Council',
  'Wyre Borough Council',
  'Wyre Forest District Council'
].sort();

const validatePasswordStrength = (password) => {
  if (!password) return { isStrong: false, checks: {} };
  
  const checks = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
  };
  
  return {
    isStrong: Object.values(checks).every(Boolean),
    checks
  };
};

const BasicInfoStep = ({ formData, handleInputChange, nextStep, errors }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState({ isStrong: false, checks: {} });

  const validateStep = () => {
    const newErrors = {};
    if (!formData.firstName?.trim()) newErrors.firstName = 'First name is required';
    if (!formData.lastName?.trim()) newErrors.lastName = 'Last name is required';
    if (!formData.email?.trim()) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Please input a valid email';
    
    // Password validation
    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else {
      const strength = validatePasswordStrength(formData.password);
      if (!strength.isStrong) {
        newErrors.password = 'Password must meet all requirements';
      }
    }
    
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your password';
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    if (!formData.address?.trim()) newErrors.address = 'Address is required';
    if (!formData.postcode?.trim()) newErrors.postcode = 'Postcode is required';
    if (!formData.localAuthorityId) newErrors.localAuthorityId = 'Local Authority is required';

    return newErrors;
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    handleInputChange(e);
    if (name === 'password') {
      setPasswordStrength(validatePasswordStrength(value));
    }
  };

  const handleNext = () => {
    const stepErrors = validateStep();
    if (Object.keys(stepErrors).length === 0) {
      nextStep();
    } else {
      handleInputChange({ target: { name: 'errors', value: stepErrors } });
    }
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="first-name" className="block text-xs font-medium text-gray-700">First Name</label>
          <div className="relative">
            <input
              id="first-name"
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              className="pl-10 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7"
              placeholder="John"
            />
            <UserIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 h-3 w-3" />
          </div>
          {errors.firstName && <p className="text-xs text-red-600">{errors.firstName}</p>}
        </div>

        <div>
          <label htmlFor="last-name" className="block text-xs font-medium text-gray-700">Last Name</label>
          <div className="relative">
            <input
              id="last-name"
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              className="pl-10 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7"
              placeholder="Doe"
            />
            <UserIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 h-3 w-3" />
          </div>
          {errors.lastName && <p className="text-xs text-red-600">{errors.lastName}</p>}
        </div>
      </div>

      <div>
        <label htmlFor="email" className="block text-xs font-medium text-gray-700">Email Address</label>
        <div className="relative">
          <input
            id="email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            className="pl-10 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7"
            placeholder="john@example.com"
          />
          <EnvelopeIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 h-3 w-3" />
        </div>
        {errors.email && <p className="text-xs text-red-600">{errors.email}</p>}
      </div>

      <div>
        <label htmlFor="password" className="block text-xs font-medium text-gray-700">Password</label>
        <div className="relative">
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            name="password"
            value={formData.password}
            onChange={handlePasswordChange}
            className="pl-10 pr-8 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7"
          />
          <LockClosedIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 h-3 w-3" />
          <button
            type="button"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeSlashIcon className="h-3 w-3" /> : <EyeIcon className="h-3 w-3" />}
          </button>
        </div>
        {errors.password && <p className="text-xs text-red-600">{errors.password}</p>}
        
        {/* Password strength indicator */}
        {formData.password && (
          <div className="mt-1">
            <div className="flex space-x-1 h-1">
              <div className={`flex-1 rounded-full transition-colors duration-200 ${
                passwordStrength.checks.length ? 'bg-blue-200' : 'bg-gray-200'
              }`}></div>
              <div className={`flex-1 rounded-full transition-colors duration-200 ${
                (passwordStrength.checks.uppercase && passwordStrength.checks.lowercase) ? 'bg-blue-300' : 'bg-gray-200'
              }`}></div>
              <div className={`flex-1 rounded-full transition-colors duration-200 ${
                passwordStrength.checks.number ? 'bg-blue-400' : 'bg-gray-200'
              }`}></div>
              <div className={`flex-1 rounded-full transition-colors duration-200 ${
                passwordStrength.checks.special ? 'bg-blue-500' : 'bg-gray-200'
              }`}></div>
            </div>
            <p className="text-[10px] text-gray-500 mt-1">
              {!passwordStrength.isStrong && "Required: "}
              {!passwordStrength.checks.length && "8+ characters, "}
              {!passwordStrength.checks.uppercase && "uppercase, "}
              {!passwordStrength.checks.lowercase && "lowercase, "}
              {!passwordStrength.checks.number && "number, "}
              {!passwordStrength.checks.special && "special char"}
              {passwordStrength.isStrong && "Strong password"}
            </p>
          </div>
        )}
      </div>

      <div>
        <label htmlFor="confirm-password" className="block text-xs font-medium text-gray-700">Confirm Password</label>
        <div className="relative">
          <input
            id="confirm-password"
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleInputChange}
            className="pl-10 pr-8 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7"
          />
          <LockClosedIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 h-3 w-3" />
          <button
            type="button"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? <EyeSlashIcon className="h-3 w-3" /> : <EyeIcon className="h-3 w-3" />}
          </button>
        </div>
        {errors.confirmPassword && <p className="text-xs text-red-600">{errors.confirmPassword}</p>}
      </div>

      <div>
        <label htmlFor="address" className="block text-xs font-medium text-gray-700">Address</label>
        <div className="relative">
          <input
            id="address"
            type="text"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            className="pl-10 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7"
            placeholder="123 Main St"
          />
          <MapPinIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 h-3 w-3" />
        </div>
        {errors.address && <p className="text-xs text-red-600">{errors.address}</p>}
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="postal-code" className="block text-xs font-medium text-gray-700">Postal Code</label>
          <input
            id="postal-code"
            type="text"
            name="postcode"
            value={formData.postcode}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7"
            placeholder="12345"
          />
          {errors.postcode && <p className="text-xs text-red-600">{errors.postcode}</p>}
        </div>

        <div>
          <label htmlFor="local-authority" className="block text-xs font-medium text-gray-700">Local Authority</label>
          <select
            id="local-authority"
            name="localAuthorityId"
            value={formData.localAuthorityId || ''}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring-blue-200 focus:ring-opacity-50 text-xs h-7 text-gray-900"
          >
            <option value="" className="text-gray-500">Select a local authority</option>
            {LOCAL_AUTHORITIES.map((authority) => (
              <option key={authority} value={authority} className="text-gray-900">
                {authority}
              </option>
            ))}
          </select>
          {errors.localAuthorityId && <p className="text-xs text-red-600">{errors.localAuthorityId}</p>}
        </div>
      </div>

      <div className="mt-6">
        <button
          type="button"
          onClick={handleNext}
          className="w-full flex justify-center py-1.5 px-3 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default BasicInfoStep;